import { useNavigate, useParams } from "react-router";
import { Post } from "src/api/client-api/post/postSchema";
import { SsqSsqHeading } from "src/api/sure-api/ssq/useGetOneSsqVersion";
import { getVisibleHeadings } from "src/utils/ssq";
import { useQuestionnaireUpdatePages } from "src/components/QuestionnaireForm/useQuestionnaireUpdatePages";
import { QuestionnaireUpdateFormBase } from "src/components/QuestionnaireForm/layouts/QuestionnaireUpdateFormBase";
import { useQuestionnaireFormContext } from "src/components/QuestionnaireForm/context/useQuestionnaireForm";
import type { FoodsPage } from "@foodpilot/foods";
import { useEffect } from "react";

export type QuestionnaireUpdatePage = {
    id: number;
} & FoodsPage;

export const QuestionnaireUpdateFormWithPages = () => {
    const { headingId } = useParams<{ headingId: string }>();
    const { ssqVersion, post, isPostLoading, refetchPost, backUrl } = useQuestionnaireFormContext();
    const navigate = useNavigate();

    const ssqSsqHeadings: SsqSsqHeading[] = getVisibleHeadings(ssqVersion, post?.hiddenElements);
    const headingsIds: number[] = ssqSsqHeadings.map((ssqSsqHeading: SsqSsqHeading) => Number(ssqSsqHeading.id));
    const headingIndex = headingsIds.findIndex((id) => id === Number(headingId));

    useEffect(() => {
        if (headingIndex === -1) {
            navigate(backUrl, { replace: true });
        }
    }, [backUrl, headingIndex, navigate]);

    const changePost = (callback: (post: Post) => void) => {
        refetchPost().then((response) => {
            if (response.data) {
                callback(response.data);
            }
        });
    };

    const { pages, isLoading } = useQuestionnaireUpdatePages({
        ssqSsqHeadings,
        ssqVersion,
        post,
        isPostLoading,
        changePost,
        allowComments: ssqVersion?.ssq.allowComments ?? false,
    });

    if (headingIndex < 0) return null;

    return <QuestionnaireUpdateFormBase pages={pages} startingPage={headingIndex ?? 0} isLoading={isLoading} />;
};
